export enum CODE {
  SUCCESS = 0,
  ERROR = -1,
}

export enum LOGGED_ENUM {
  LOGGED = "logged",
}

export enum FOLLOW_FLG_ENUM {
  FOLLOWED = 0,
  FOLLOW = -7,
}

export interface SessionI {
  error: CODE;
  atk?: string;
}

export interface FollowI {
  error: CODE;
  followFlg: FOLLOW_FLG_ENUM;
  isLogged: string;
  uid: string;
}
